import React, { ReactNode } from 'react';
import { TFunction, withTranslation, WithTranslation } from 'next-i18next';

import { FieldLabel, RequiredFlag } from './styles';

interface LabelProps extends WithTranslation {
    t: TFunction;
    id: string;
    size: 'default' | 'large';
    readonly?: boolean;
    children: string | ReactNode;
    addRequiredFlag: boolean | undefined;
    showRequirementFlag?: boolean;
    className?: string;
}

const Label = ({
    t,
    id,
    size = 'default',
    readonly = false,
    children,
    addRequiredFlag,
    showRequirementFlag = true,
    className,
}: LabelProps) => {
    return (
        <FieldLabel className={className} htmlFor={id} $size={size} $readonly={readonly}>
            {children}
            {showRequirementFlag &&
                (addRequiredFlag ? (
                    <RequiredFlag> ({t('required')})</RequiredFlag>
                ) : (
                    <RequiredFlag> ({t('optional')})</RequiredFlag>
                ))}
        </FieldLabel>
    );
};

export default withTranslation('common')(Label);
